import { fetcher } from '@commenda/utils';

export async function deleteMemberFromAffiliateFirm(
  affiliateFirmId: string,
  userIdToDelete: string,
  userId?: string
) {
  const queryParams = userId ? `?userId=${userId}` : '';
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/member/${userIdToDelete}${queryParams}`,
    {
      method: 'DELETE',
    }
  );

  return response;
}
